import styled from "styled-components";
import { ThemeType } from "../../types/Theme";

export const ModalLayoutImpressaoContainer = styled.div<{ theme: ThemeType }>`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-height: 80vh;

    .header {
        text-align: center;

        h2 {
            margin: 0 0 0.8rem 0;
            color: ${({theme}) => theme.colors.secondary};
        }

        .subtitulo {
            margin: 0;
            color: ${({theme}) => theme.colors.tertiary};
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 2.4rem;
        max-height: 50vh;
        overflow-y: auto;
        padding-right: 1rem;
    }

    .secao {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;

        .secao-titulo {
            margin: 0;
            position: relative;
            padding-bottom: 2rem;
            padding-top: 1rem;
            color: ${({theme}) => theme.colors.tertiary};

            &:after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 1px;
                border-radius: 10rem;
                background-color: ${({theme}) => theme.colors.elements};

            }
        }
    }

    .campos-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.2rem;

        @media (max-width: 500px) {
            grid-template-columns: 1fr;
        }
    }

    .campo {
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        padding: 0.6rem 0;

        span {
            color: ${({theme}) => theme.colors.tertiary};
        }

    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 1.6rem;
        flex-wrap: wrap;
        gap: 1.2rem;

        .botoes-principais {
            display: flex;
            gap: 5rem;
        }

        .botao-reset {
            background-color: transparent;
            color: ${(props) => props.theme.colors.tertiary};
            padding: 0 !important;
        }

        .botao-cancelar {
            background-color: transparent;
            color: ${(props) => props.theme.colors.primary};
            padding: 0 !important;
        }

        .botao-salvar {
            padding: 0.8rem 3rem;
        }
    }

    @media (max-width: 500px) {
        .footer {
            flex-direction: column;

            .botao-reset {
                order: 3;
                width: 100%;
            }

            .botoes-principais {
                width: 100%;

                button {
                    flex: 1;
                }
            }
        }
    }
`;
